import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ICON } from '@core/util/icon';
import { DirectionOfFeeType } from '@models/businessSettings/directionOfFees';
import { Store } from '@ngxs/store';
import {
	AnalyticsEvent,
	AnalyticsService,
} from '@services/analytics/analytics.service';
import { BusinessDispatch, BusinessState } from '@state/business';
import { BaseBusinessSettingsSection } from '../business-finances-general/common/base-business-settings-section/base-business-settings-section.directive';
import { TestHooks } from './ltt-settings.hooks';

@Component({
	selector: 'app-ltt-settings',
	templateUrl: './ltt-settings.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class LttSettingsComponent extends BaseBusinessSettingsSection {
	testHooks = TestHooks;
	private businessDispatch: BusinessDispatch = inject(BusinessDispatch);
	private analytics: AnalyticsService = inject(AnalyticsService);

	public ICON = ICON;
	public showFeeOptions = [
		{
			label: 'Trust Ledger',
			value: DirectionOfFeeType.TRUST_LEDGER,
		},
		{
			label: 'Statement of Account',
			value: DirectionOfFeeType.SOA,
		},
	];
	public settings$ = inject(Store).select(BusinessState.getLTTSettings);
	public directionOfFeeType = DirectionOfFeeType;

	setDisplayIn(displayIn: DirectionOfFeeType): void {
		this.analytics.logEvent(
			AnalyticsEvent.LTT_SETTINGS_DISPLAY_DROPDOWN_CHANGE_CLICK,
			{ displayIn },
		);
	}

	setSeparateEntities(separateEntities: boolean): void {
		this.analytics.logEvent(
			AnalyticsEvent.LTT_SETTINGS_SINGLE_SEPARATE_ENTRY_CHECKBOX_CHANGE_CLICK,
			{ separateEntities },
		);
		this.businessDispatch.OverwriteBusinessFields(
			'defaultSettings.LTT.separateEntities',
			separateEntities,
		);
	}

	setShowAdminFeeIn(
		showAdminFeeIn: DirectionOfFeeType.TRUST_LEDGER | DirectionOfFeeType.SOA,
	): void {
		this.analytics.logEvent(
			AnalyticsEvent.LTT_SETTINGS_MLTT_ADMIN_FEE_TOGGLE_CHANGE_CLICK,
			{ showAdminFeeIn },
		);
		this.businessDispatch.OverwriteBusinessFields(
			'defaultSettings.LTT.showAdminFeeIn',
			showAdminFeeIn,
		);
	}
}
